'use client'

import React, { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Check, Copy } from 'lucide-react'

export const ShareButton: React.FC = () => {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    const currentUrl = window.location.href
    navigator.clipboard.writeText(currentUrl)
    setCopied(true)

    setTimeout(() => {
      setCopied(false) // Reset after 2 seconds
    }, 2000)
  }

  return (
    <div>
      <Button
        variant="default"
        onClick={handleCopy}
        className="flex items-center space-x-2"
      >
        {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
        <span>{copied ? 'Copied!' : 'Share this prompt'}</span>
      </Button>
    </div>
  )
}
